module.exports = __webpack_public_path__ + "img/GAME_OILPAINT2.1f13f7ef.jpg";